import Vue from 'vue';

export default {
  /**
   * Is the user using internet exploer
   *
   * @returns {boolean}
   */
  isIE() {
    return !Vue.prototype.$isServer && !Number.isNaN(Number(document.documentMode));
  },

  /**
   * Is the user using edge
   *
   * @returns {boolean}
   */
  isEdge() {
    return !Vue.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
  },
};
